/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Board_Vote_LabelInputs */

const en_us2_board_vote_label = /** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Support: ${i?.text}`)
};

const pt_br2_board_vote_label = /** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apoiar: ${i?.text}`)
};

const pt_pt2_board_vote_label = /** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apoiar: ${i?.text}`)
};

/** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */
const es_419_board_vote_label = en_us2_board_vote_label;

/** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */
const fr_fr2_board_vote_label = en_us2_board_vote_label;

/** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */
const de_de2_board_vote_label = en_us2_board_vote_label;

/** @type {(inputs: Board_Vote_LabelInputs) => LocalizedString} */
const it_it2_board_vote_label = en_us2_board_vote_label;

/**
* | output |
* | --- |
* | "Support: {text}" |
*
* @param {Board_Vote_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_vote_label = /** @type {((inputs: Board_Vote_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Vote_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_vote_label(inputs)
	if (locale === "es-419") return es_419_board_vote_label(inputs)
	if (locale === "pt-PT") return pt_pt2_board_vote_label(inputs)
	if (locale === "fr-FR") return fr_fr2_board_vote_label(inputs)
	if (locale === "de-DE") return de_de2_board_vote_label(inputs)
	if (locale === "it-IT") return it_it2_board_vote_label(inputs)
	return en_us2_board_vote_label(inputs)
});
export { board_vote_label as "board.vote_label" }